import { handleAPIError } from "@services/Base";
import { useQuery } from "@tanstack/react-query";
import axios from "axios";
import { MODEL_API_URL } from "../../../config";
import { ModelResponseCurveDetail } from "../types";

export const useModelMediaResponseCurve = (
  media_id: number,
  model_id: number
) => {
  return useQuery({
    queryKey: ["model", "charts", "response_curve", media_id, model_id],
    enabled: model_id > 0 && media_id > 0,
    queryFn: ({ signal }) =>
      axios
        .get(
          `${MODEL_API_URL}/waves-model-manager-api/v1/models/${model_id}/charts/response_curves/${media_id}`,
          {
            signal
          }
        )
        .then((response) => {
          return response.data as ModelResponseCurveDetail;
        })
        .catch((error) => {
          return handleAPIError(error);
        })
  });
};
